import { AddIcon } from "@chakra-ui/icons";
import {
  Button,
  FormControl,
  FormHelperText,
  FormLabel,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  useDisclosure,
} from "@chakra-ui/react";
import { useState } from "react";

type UploadResourcesProps = {
  onDataUploaded: (file: File, resourcesType: string) => void;
};

const UploadResources = (props: UploadResourcesProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [file, setFile] = useState<File | null>(null);
  const [resourcesType, setResourcesType] = useState<string>('images');

  function handleChange(e: any) {
    setFile(e.target.files[0]);
  }

  function handleClick() {
    if (file) {
      props.onDataUploaded(file, resourcesType);
    }
    onClose();
  }

  return (
    <>
      <Button leftIcon={<AddIcon />} colorScheme="teal" onClick={onOpen}>
        Subir archivos
      </Button>
      <Modal blockScrollOnMount={false} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Nuevos archivos</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
          <FormControl  id="type-form-control" paddingBottom="6">
            <FormLabel>Tipo de archivos</FormLabel>
              <RadioGroup id='file-type' onChange={setResourcesType} value={resourcesType}>
                <HStack spacing='15px'>
                  <Radio value='images' isChecked={true}>Imágenes</Radio>
                  <Radio value='audio'>Audios</Radio>
                </HStack>
              </RadioGroup>
            </FormControl>

            <FormControl id="file-form-control" paddingBottom="6">
              <FormLabel>Archivos</FormLabel>
              <input name="file-input" type="file" onChange={handleChange} />
              <FormHelperText>
                Seleccione un archivo comprimido para subir los archivos.
              </FormHelperText>
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="teal"
              type="submit"
              isDisabled={!file}
              onClick={handleClick}
            >
              Subir
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default UploadResources;
